import { render, staticRenderFns } from "./ScoreReview.vue?vue&type=template&id=95ed6e18&scoped=true&"
import script from "./ScoreReview.vue?vue&type=script&lang=js&"
export * from "./ScoreReview.vue?vue&type=script&lang=js&"
import style0 from "./ScoreReview.vue?vue&type=style&index=0&id=95ed6e18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ed6e18",
  null
  
)

export default component.exports